import { useReducer } from "react";
import { useDispatch } from 'react-redux';

import { setStoreHistory } from "../actions/index";

const historyReducer = (state, action) => {
  switch(action.type) {
    case 'prev':
      const indexPrev = state.findIndex(x => x.active) - 1;
      action.globalHistory.push(state[indexPrev].path);
      return [...state.map( (x,i) => { x.active = (indexPrev === i); return x }) ]
    case 'next':
      const indexNext = state.findIndex(x => x.active) + 1;
      action.globalHistory.push(state[indexNext].path);
      return [...state.map( (x,i) => { x.active = (indexNext === i); return x }) ]
    case 'update':
      const index = state.findIndex(x => x.active);
      return [...state.slice(0, index + 1).map( x => { x.active = false; return x; }), { path: action.path, active: true }]
    case 'delete':
      const last = state.findIndex(x => x.active);
      return [...state.slice(0, last).map( x => { x.active = false; return x; }), { path: `/`, active: true }]
    default:
      return state;
  }
}

const useStoreHistory = (path = `/`) => {
  const dispatch = useDispatch();
  const [history, dispatchHistory] = useReducer(historyReducer, [{ path, active: true }]);
  let store = {
    history,
    prev: (globalHistory) => dispatchHistory({type: `prev`, globalHistory}),
    next: (globalHistory) => dispatchHistory({type: `next`, globalHistory}),
    updateHistory: (path) => dispatchHistory({type: `update`, path}),
    deleteLastHistory: () => dispatchHistory({type: `delete`})
  };
  setTimeout(() => { dispatch(setStoreHistory(store)) }, 100);
  return store;
};

export default useStoreHistory;
